module.exports = __webpack_public_path__ + "img/2262.17c07369.gif";